import DataProvider from './context/data/Provider'
import Modal from 'components/Modal/Modal'
import LeafletMap from './LeafletMap'
import Search from './Search'
import React from 'react'
import './style.scss'

interface Point {
  id: string
  name: string
  service: string
}

export type CloseCallback = (point?: Point) => void

interface DeliveryPointsModalProps {
  search?: string
  showModal?: boolean
  placeAddress?: string
  initialZoom?: number
  initialServices?: string[]
  initialCoordinates?: [number, number]
  close: CloseCallback
}

export const allServices = ['mm', 'inpost', 'dpd', 'dhl', 'ups', 'fedex', 'orlen', 'poczta']

const DeliveryPointsModal: React.FC<DeliveryPointsModalProps> = ({ search, placeAddress, initialServices = allServices, initialCoordinates, initialZoom, showModal = true, close }) => {
  const body = <DataProvider
    placeAddress={placeAddress}
    initialServices={initialServices}
    initialCoordinates={initialCoordinates}>
    <div className='modal__deliveryPoints'>
      <Search
        initialSearch={search}
        initialServices={initialServices} />
      <LeafletMap
        initialZoom={initialZoom}
        close={close} />
    </div>
  </DataProvider>

  if (!showModal) return body
  return (
    <Modal
      isLargeModal
      title='Punkty odbioru'
      secondaryButton='Anuluj'
      secondaryButtonAction='close'
      onClose={() => {
        close()
      }}>
      {body}
    </Modal>
  )
}

export default DeliveryPointsModal